import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

function dm_c10() {
    // gsap.registerPlugin(DrawSVGPlugin);
    // gsap.registerPlugin(ScrollTrigger);
    gsap.registerPlugin(DrawSVGPlugin, ScrollTrigger, ScrollToPlugin);

    const $c10_module = $('section.c-10-icon-slider');
    if (!$c10_module.length) return;

    const $navContainer = $c10_module.find('.c10-filters');
    if (!$navContainer.length) return;
    const $filters = $navContainer.find('.c10-filter');
    const $icons = $c10_module.find('.c10-icon');
    const $contents = $c10_module.find('.c10-content');

    $filters.on('click', function(e) {
        e.preventDefault();
        const $filter = $(this);
        const index = $filter.data('index');
        $filters.removeClass('is-active');
        $icons.removeClass('is-active');
        $filter.addClass('is-active');

        const $icon = $c10_module.find(`.c10-icon[data-index="${index}"]`);
        $icons.not($icon).removeClass('is-active').hide();
        if ($icon.length) {
            $icon.show().addClass('is-active');
        }

        const $contentToShow = $c10_module.find(`.c10-content[data-index="${index}"]`);
        $contents.not($contentToShow).removeClass('is-active').hide();
        if ($contentToShow.length) {
            $contentToShow.show().addClass('is-active');
            // $contentToShow.addClass('is-active').hide().fadeIn('fast');
            // $('.c10-reveal').hide().fadeIn('fast');
        }

        const linkRect = this.getBoundingClientRect();
        const containerRect = $navContainer[0].getBoundingClientRect();
        const targetLeft = linkRect.left - containerRect.left + $navContainer.scrollLeft();
        gsap.to($navContainer, {
            scrollTo: { x: targetLeft },
            duration: 0.5,
            ease: 'power2.out'
        });
    });


    const swipeContainers = document.querySelectorAll('.c10-contents, .c10-icons');
    swipeContainers.forEach(container => {
        let touchStartX = 0;
        let touchEndX = 0;

        container.addEventListener('touchstart', function (e) {
            touchStartX = e.changedTouches[0].screenX;
        }, false);

        container.addEventListener('touchend', function (e) {
            touchEndX = e.changedTouches[0].screenX;
            handleSwipe();
        }, false);

        function handleSwipe() {
            const diff = touchStartX - touchEndX;
            if (Math.abs(diff) > 50) {
                const active = document.querySelector('.c10-filters .slide-title.is-active');
                if (!active) return;

                let target = diff > 0
                    ? active.nextElementSibling 
                    : active.previousElementSibling;

                if (target && target.classList.contains('slide-title')) {
                    target.click();
                }
            }
        }
    });
}

export { dm_c10 };